export const SUPPORTED_LOCALES = [
  "en",
  "de"
] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export type LocalizedString = Record<SupportedLocale, string>;

export const currentLocale: SupportedLocale = "de";
